import React from 'react';
import { Link } from 'react-router-dom';

const footerStyle = {
  background: 'white',
  color: '#86868b',
  textAlign: 'center',
  padding: '32px 20px 16px 20px',
  fontSize: 15,
  borderTop: '1px solid #e5e5e5',
  margin: '0',
};

const linksContainerStyle = {
  marginBottom: '16px',
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '20px',
};

const linkStyle = {
  color: '#86868b',
  textDecoration: 'none',
  fontSize: 15,
  transition: 'color 0.2s ease',
};

const linkHoverStyle = {
  color: '#0071e3',
};

const copyrightStyle = {
  fontSize: 13,
  color: '#86868b',
};

export default function Footer() {
  return (
    <footer style={footerStyle}>
      <div style={linksContainerStyle}>
        <Link 
          to="/privacy" 
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.color = '#0071e3'}
          onMouseLeave={(e) => e.target.style.color = '#86868b'}
        >
          Privacy Policy
        </Link>
        <span style={{ color: '#86868b' }}>|</span>
        <Link 
          to="/terms" 
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.color = '#0071e3'}
          onMouseLeave={(e) => e.target.style.color = '#86868b'}
        >
          Terms of Service
        </Link>
      </div>
      <div style={copyrightStyle}>
        &copy; {new Date().getFullYear()} MyPictor&trade;. All rights reserved.
      </div>
    </footer>
  );
}
